import React from 'react';

/**
 * Minimal SVG sparkline. Auto-colors green if last >= first, red otherwise.
 * Adds a soft gradient fill under the line.
 */
export default function Sparkline({
  values = [],
  width = 220,
  height = 56,
  stroke,
  baseline,        // optional y-value to draw a dashed reference line at
  min: minProp,
  max: maxProp,
}) {
  if (!values || values.length === 0) {
    return (
      <div
        style={{
          height, width: '100%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: 'rgba(255,255,255,0.3)', fontSize: 11,
          background: 'rgba(255,255,255,0.02)',
          border: '1px dashed rgba(255,255,255,0.08)',
          borderRadius: 6,
        }}
      >
        no data
      </div>
    );
  }
  if (values.length === 1) values = [values[0], values[0]];

  let min = (minProp != null) ? minProp : Math.min(...values);
  let max = (maxProp != null) ? maxProp : Math.max(...values);
  // Pad min/max a touch so the line doesn't hug the edges; ensures movement
  // is visible even when win rate is flat-ish.
  if (max - min < 5) { min = Math.max(0, min - 5); max = max + 5; }
  const range = max - min || 1;
  const stepX = width / (values.length - 1);
  const points = values.map((v, i) => {
    const x = i * stepX;
    const y = height - ((v - min) / range) * (height - 6) - 3;
    return [x, y];
  });

  const line = points.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
  const area = `${line} L${width},${height} L0,${height} Z`;
  const up   = values[values.length - 1] >= values[0];
  const color = stroke || (up ? '#00d6b4' : '#fd5d93');
  const gid = 'sg' + Math.random().toString(36).slice(2, 9);

  return (
    <svg width="100%" height={height} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor={color} stopOpacity="0.32" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill={`url(#${gid})`} />
      {baseline != null && baseline >= min && baseline <= max && (
        <line
          x1={0}
          x2={width}
          y1={height - ((baseline - min) / range) * (height - 6) - 3}
          y2={height - ((baseline - min) / range) * (height - 6) - 3}
          stroke="rgba(255,255,255,0.25)"
          strokeWidth="1"
          strokeDasharray="3 3"
        />
      )}
      <path d={line} fill="none" stroke={color} strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
